<template>
    <div>
      <el-button style="margin-bottom: 20px" type="primary" icon="el-icon-back" @click="$router.go(-1)" plain>{{ $t('back') }}</el-button>
    </div>
</template>

<script>
  export default {
    data() {
      return {
        msg: 'Hi there!'
      }
    }
  }
</script>

<style scoped>
  .super-class {
    background: #4b79b6;
  }
</style>